module.exports = __webpack_public_path__ + "img/red_women.78ca08c5.svg";